import { AttributeType } from "../../../clients/Purchaser/Attributes";
import type { FileAttributeFilter, SetAttributeFilter } from "../types";
import SetFilterItems from "./SetFilterItems";

type FileAttributeFilterSubmenuProps = {
    attributeId: number;
    currentFilter?: FileAttributeFilter;
    setAttributeFilter: SetAttributeFilter;
};

function FileAttributeFilterSubmenu({ attributeId, currentFilter, setAttributeFilter }: FileAttributeFilterSubmenuProps) {
    return <SetFilterItems type={AttributeType.FILE} attributeId={attributeId} currentSet={currentFilter?.set} setAttributeFilter={setAttributeFilter} />;
}

export default FileAttributeFilterSubmenu;
